/**
 * This function removes zero width characters from strings.
 *
 * Regex below will match with following characters:
 * - U+200B Zero-width space
 * - U+200C Zero-width non-joiner
 * - U+200D Zero-width joiner
 * - U+2060 Word joiner
 * - U+FEFF Zero-width no-break space
 */

const zeroWidthCharRegex = /[\u200B-\u200D\uFEFF\u2060]/g;

export const removeZeroWidthCharactersFromString = (str: string) => {
  return str.replace(zeroWidthCharRegex, '');
};
